import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
// Types
import mixins from "vue-typed-mixins"; // Mixins
import { LinkOptionsModalEvents } from '../modals/LinkOptionsModal';
import EditorBase from '../../mixins/EditorBase';
import { WithRefs } from '../../utils/withRefs';

// Enums
import { Modals } from '../../enums/Modals';
const EditorLink = mixins(LinkOptionsModalEvents, EditorBase(() => null), WithRefs()).extend({
  name: 'EditorLink',
  props: {
    // TODO: remove stuff
    buttonBottom: {
      type: Boolean,
      default: false
    },
    buttonClass: {
      type: String,
      default: ''
    },
    block: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    focus() {
      var _this$$refs$selectBut;
      (_this$$refs$selectBut = this.$refs.selectButton) === null || _this$$refs$selectBut === void 0 ? void 0 : _this$$refs$selectBut.focus(); // todo: isn't working
    }
  },

  render() {
    var _this$$scopedSlots$de, _this$$scopedSlots, _this$computedValue, _this$computedValue2, _this$computedValue3;
    const h = arguments[0];
    return h("div", {
      "class": `relative ${this.block ? 'flex' : 'inline-flex'}`
    }, [h("div", {
      "class": "flex-1"
    }, [((_this$$scopedSlots$de = (_this$$scopedSlots = this.$scopedSlots).default) === null || _this$$scopedSlots$de === void 0 ? void 0 : _this$$scopedSlots$de.call(_this$$scopedSlots, {
      path: ((_this$computedValue = this.computedValue) === null || _this$computedValue === void 0 ? void 0 : _this$computedValue.formattedPath) || '',
      item: this.computedValue,
      name: ((_this$computedValue2 = this.computedValue) === null || _this$computedValue2 === void 0 ? void 0 : _this$computedValue2.name) || ''
    })) || ((_this$computedValue3 = this.computedValue) === null || _this$computedValue3 === void 0 ? void 0 : _this$computedValue3.name)]), this.$isInEditMode && h("button", _mergeJSXProps([{
      "ref": "selectButton"
    }, {
      directives: [{
        name: 'tooltip',
        value: {
          classes: 'px-2 py-1 shadow-md rounded-sm bg-white z-core-menu',
          content: this.$at('core.action.editLink')
        },
        modifiers: {
          right: true
        }
      }]
    }, {
      "class": ['bg-white p-1 h-8 w-8', this.buttonClass],
      "attrs": {
        "type": "button"
      },
      "on": {
        "click": () => this.$modal.show(Modals.LinkOptions, {
          link: this.computedValue,
          onConfirm: v => this.computedValue = v
        })
      }
    }]), [h("em", {
      "class": "core-icon-link"
    })])]);
  }
});
export default EditorLink;